<script setup>
import PdfViewer from '@templates/pdfViewer/PdfViewer.vue';
import { url } from '@/config/urls';
</script>

<template>
    <PdfViewer title="マニュアル" :api-url=url.api.manual.pdf />
</template>